// This file is not localized on purpose as it's a DE-only integration

import { WorkingPlanType } from './types';

export const GFEA_HELP_ARTICLE_URL = 'https://support.recruitee.com/articles/5099384';
export const GFEA_WEBSITE_URL = 'https://www.arbeitsagentur.de/';

// Countries must be sorted alphabetically by name, with Germany being the first country
export const COUNTRIES = [
  { code: 'DE', name: 'Deutschland' },
  { code: 'BE', name: 'Belgien' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'DK', name: 'Dänemark' },
  { code: 'ES', name: 'Estland' },
  { code: 'FI', name: 'Finnland' },
  { code: 'FR', name: 'Frankreich' },
  { code: 'GR', name: 'Griechenland' },
  { code: 'GB', name: 'Großbritannien' },
  { code: 'IE', name: 'Irland' },
  { code: 'IT', name: 'Italien' },
  { code: 'LV', name: 'Lettland' },
  { code: 'LT', name: 'Lithauen' },
  { code: 'NL', name: 'Niederlande' },
  { code: 'NO', name: 'Norwegen' },
  { code: 'AT', name: 'Österreich' },
  { code: 'PL', name: 'Polen' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Rumänien' },
  { code: 'SE', name: 'Schweden' },
  { code: 'CH', name: 'Schweiz' },
  { code: 'SI', name: 'Slovakei' },
  { code: 'ES', name: 'Spanien' },
  { code: 'CZ', name: 'Tschechische Republik' },
  { code: 'HU', name: 'Ungarn' },
];

export const COUNTRY_CODES = COUNTRIES.map(country => country.code);

export const REGIONS = [
  { countryCode: 'DE', name: 'Baden-Württemberg', vamCode: '1' },
  { countryCode: 'DE', name: 'Bayern', vamCode: '2' },
  { countryCode: 'DE', name: 'Berlin', vamCode: '3' },
  { countryCode: 'DE', name: 'Brandenburg', vamCode: '4' },
  { countryCode: 'DE', name: 'Bremen', vamCode: '5' },
  { countryCode: 'DE', name: 'Hamburg', vamCode: '6' },
  { countryCode: 'DE', name: 'Hessen', vamCode: '7' },
  { countryCode: 'DE', name: 'Mecklenburg-Vorpommern', vamCode: '8' },
  { countryCode: 'DE', name: 'Niedersachsen', vamCode: '9' },
  { countryCode: 'DE', name: 'Nordrhein-Westfalen', vamCode: '10' },
  { countryCode: 'DE', name: 'Rheinland-Pfalz', vamCode: '11' },
  { countryCode: 'DE', name: 'Saarland', vamCode: '12' },
  { countryCode: 'DE', name: 'Sachsen', vamCode: '13' },
  { countryCode: 'DE', name: 'Sachsen-Anhalt', vamCode: '14' },
  { countryCode: 'DE', name: 'Schleswig-Holstein', vamCode: '15' },
  { countryCode: 'DE', name: 'Thüringen', vamCode: '16' },
  { countryCode: 'FR', name: 'Alsace', vamCode: '19' },
  { countryCode: 'FR', name: 'Aquitaine', vamCode: '20' },
  { countryCode: 'FR', name: 'Auvergne', vamCode: '21' },
  { countryCode: 'FR', name: 'Basse-Normandie', vamCode: '22' },
  { countryCode: 'FR', name: 'Bourgogne', vamCode: '23' },
  { countryCode: 'FR', name: 'Bretagne', vamCode: '24' },
  { countryCode: 'FR', name: 'Centre', vamCode: '25' },
  { countryCode: 'FR', name: 'Champagne-Ardenne', vamCode: '26' },
  { countryCode: 'FR', name: 'Corse', vamCode: '27' },
  { countryCode: 'FR', name: 'Franche-Comte', vamCode: '28' },
  { countryCode: 'FR', name: 'Guadeloupe', vamCode: '29' },
  { countryCode: 'FR', name: 'Guyane', vamCode: '30' },
  { countryCode: 'FR', name: 'Haute-Normandie', vamCode: '31' },
  { countryCode: 'FR', name: 'Ile de France', vamCode: '32' },
  { countryCode: 'FR', name: 'Languedoc-Roussillion', vamCode: '33' },
  { countryCode: 'FR', name: 'Limousin', vamCode: '34' },
  { countryCode: 'FR', name: 'Lorraine', vamCode: '35' },
  { countryCode: 'FR', name: 'Martinique', vamCode: '36' },
  { countryCode: 'FR', name: 'Midi-Pyrenees', vamCode: '37' },
  { countryCode: 'FR', name: 'Nord-Pas-de-Calais', vamCode: '38' },
  { countryCode: 'FR', name: 'Pays de la Loire', vamCode: '39' },
  { countryCode: 'FR', name: 'Picardie', vamCode: '40' },
  { countryCode: 'FR', name: 'Poitou-Charentes', vamCode: '41' },
  { countryCode: 'FR', name: "Provence-Alpes-Cote d'Azur", vamCode: '42' },
  { countryCode: 'FR', name: 'Reunion', vamCode: '43' },
  { countryCode: 'FR', name: 'Rhone-Alpes', vamCode: '44' },
  { countryCode: 'IT', name: 'Abruzzi-Molise', vamCode: '45' },
  { countryCode: 'IT', name: 'Basilicata', vamCode: '46' },
  { countryCode: 'IT', name: 'Calabria', vamCode: '47' },
  { countryCode: 'IT', name: 'Campania', vamCode: '48' },
  { countryCode: 'IT', name: 'Emilia-Romagna', vamCode: '49' },
  { countryCode: 'IT', name: 'Friuli-Venezia Giulia', vamCode: '50' },
  { countryCode: 'IT', name: 'Lazio (mit Rom)', vamCode: '51' },
  { countryCode: 'IT', name: 'Liguria', vamCode: '52' },
  { countryCode: 'IT', name: 'Lombardia', vamCode: '53' },
  { countryCode: 'IT', name: 'Marche', vamCode: '54' },
  { countryCode: 'IT', name: 'Piemonte', vamCode: '55' },
  { countryCode: 'IT', name: 'Puglia', vamCode: '56' },
  { countryCode: 'IT', name: 'Sardegna', vamCode: '57' },
  { countryCode: 'IT', name: 'Sicilia', vamCode: '58' },
  { countryCode: 'IT', name: 'Toscana', vamCode: '59' },
  { countryCode: 'IT', name: 'Trentino-Altoadige (mit Südtirol)', vamCode: '60' },
  { countryCode: 'IT', name: 'Umbria', vamCode: '61' },
  { countryCode: 'IT', name: "Valle d'Aosta", vamCode: '62' },
  { countryCode: 'IT', name: 'Veneto', vamCode: '63' },
  { countryCode: 'NL', name: 'Drenthe', vamCode: '64' },
  { countryCode: 'NL', name: 'Flevoland', vamCode: '65' },
  { countryCode: 'NL', name: 'Friesland', vamCode: '66' },
  { countryCode: 'NL', name: 'Gelderland', vamCode: '67' },
  { countryCode: 'NL', name: 'Groningen', vamCode: '68' },
  { countryCode: 'NL', name: 'Limburg', vamCode: '69' },
  { countryCode: 'NL', name: 'Noord-Brabant', vamCode: '70' },
  { countryCode: 'NL', name: 'Noord-Holland', vamCode: '217' },
  { countryCode: 'NL', name: 'Overijssel', vamCode: '71' },
  { countryCode: 'NL', name: 'Utrecht', vamCode: '72' },
  { countryCode: 'NL', name: 'Zeeland', vamCode: '73' },
  { countryCode: 'NL', name: 'Zuid-Holland', vamCode: '74' },
  { countryCode: 'BE', name: 'Antwerpen', vamCode: '75' },
  { countryCode: 'BE', name: 'Brabant', vamCode: '76' },
  { countryCode: 'BE', name: 'Bruxelles-Brussel', vamCode: '77' },
  { countryCode: 'BE', name: 'Hainaut', vamCode: '78' },
  { countryCode: 'BE', name: 'Liège', vamCode: '79' },
  { countryCode: 'BE', name: 'Limburg', vamCode: '80' },
  { countryCode: 'BE', name: 'Luxembourg', vamCode: '81' },
  { countryCode: 'BE', name: 'Namur', vamCode: '82' },
  { countryCode: 'BE', name: 'Ost-Vlandern', vamCode: '83' },
  { countryCode: 'BE', name: 'West-Vlandern', vamCode: '84' },
  { countryCode: 'GB', name: 'Avon, Gloucestershire, Wiltshire', vamCode: '85' },
  { countryCode: 'GB', name: 'Bedfordshire, Hartfordshire', vamCode: '86' },
  { countryCode: 'GB', name: 'Berkshire, Buckinghamshire, Oxfordshire', vamCode: '87' },
  {
    countryCode: 'GB',
    name: 'Borders, Central, Fife, Lothian, Tayside (Schottland)',
    vamCode: '88',
  },
  { countryCode: 'GB', name: 'Cheshire', vamCode: '89' },
  { countryCode: 'GB', name: 'Cleveland, Durham', vamCode: '90' },
  { countryCode: 'GB', name: 'Clwyd, Dyfed, Gwynedd, Powys (Wales)', vamCode: '91' },
  { countryCode: 'GB', name: 'Cornwall, Devon', vamCode: '92' },
  { countryCode: 'GB', name: 'Cumbria', vamCode: '93' },
  { countryCode: 'GB', name: 'Derbyshire, Nottinghamshire', vamCode: '94' },
  { countryCode: 'GB', name: 'Dorset, Somerset', vamCode: '95' },
  { countryCode: 'GB', name: 'Dumfries-Galloway, Strathclyde (Schottland)', vamCode: '96' },
  { countryCode: 'GB', name: 'East Anglia (Cambridgeshire, Norfolk, Suffolk)', vamCode: '97' },
  { countryCode: 'GB', name: 'Essex', vamCode: '98' },
  { countryCode: 'GB', name: 'Grampian (Schottland)', vamCode: '99' },
  { countryCode: 'GB', name: 'Greater London', vamCode: '100' },
  { countryCode: 'GB', name: 'Greater Manchester', vamCode: '101' },
  { countryCode: 'GB', name: 'Gwent, Mid-South-West-Glamorgan (Wales)', vamCode: '102' },
  { countryCode: 'GB', name: 'Hampshire, Isle of Wight', vamCode: '103' },
  { countryCode: 'GB', name: 'Hereford-Worcester, Warwickshire', vamCode: '105' },
  { countryCode: 'GB', name: 'Highlands, Islands (Scotland)', vamCode: '106' },
  { countryCode: 'GB', name: 'Kent', vamCode: '107' },
  { countryCode: 'GB', name: 'Lancashire', vamCode: '108' },
  { countryCode: 'GB', name: 'Leicestershire, Northamptonshire', vamCode: '109' },
  { countryCode: 'GB', name: 'Lincolnshire', vamCode: '110' },
  { countryCode: 'GB', name: 'Merseyside', vamCode: '111' },
  { countryCode: 'GB', name: 'North Yorkshire', vamCode: '112' },
  { countryCode: 'GB', name: 'Northern Ireland', vamCode: '113' },
  { countryCode: 'GB', name: 'Northumberland, Tyne and Wear', vamCode: '114' },
  { countryCode: 'GB', name: 'Shropshire, Staffordshire', vamCode: '115' },
  { countryCode: 'GB', name: 'South Yorkshire', vamCode: '116' },
  { countryCode: 'GB', name: 'Surrey, East-West Sussex', vamCode: '117' },
  { countryCode: 'GB', name: 'West Midlands (County)', vamCode: '118' },
  { countryCode: 'GB', name: 'West Yorkshire', vamCode: '119' },
  { countryCode: 'IE', name: 'Donegal', vamCode: '120' },
  { countryCode: 'IE', name: 'East (mit Dublin)', vamCode: '121' },
  { countryCode: 'IE', name: 'Mid West', vamCode: '122' },
  { countryCode: 'IE', name: 'Midlands', vamCode: '123' },
  { countryCode: 'IE', name: 'South East', vamCode: '126' },
  { countryCode: 'IE', name: 'South West', vamCode: '127' },
  { countryCode: 'IE', name: 'West', vamCode: '128' },
  { countryCode: 'GR', name: 'Anatoliki Makedonia, Thraki', vamCode: '144' },
  { countryCode: 'GR', name: 'Attiki', vamCode: '145' },
  { countryCode: 'GR', name: 'Dytiki Ellada', vamCode: '146' },
  { countryCode: 'GR', name: 'Dytiki Makedonia', vamCode: '147' },
  { countryCode: 'GR', name: 'Ionia Nisia', vamCode: '148' },
  { countryCode: 'GR', name: 'Ipeiros', vamCode: '149' },
  { countryCode: 'GR', name: 'Kentriki Makedonia', vamCode: '150' },
  { countryCode: 'GR', name: 'Kriti', vamCode: '151' },
  { countryCode: 'GR', name: 'Notio Aigaio', vamCode: '152' },
  { countryCode: 'GR', name: 'Peloponnisos', vamCode: '153' },
  { countryCode: 'GR', name: 'Sterea Ellada', vamCode: '154' },
  { countryCode: 'GR', name: 'Thessalia', vamCode: '155' },
  { countryCode: 'ES', name: 'Andalucia', vamCode: '157' },
  { countryCode: 'ES', name: 'Aragon', vamCode: '158' },
  { countryCode: 'ES', name: 'Asturias', vamCode: '159' },
  { countryCode: 'ES', name: 'Baleares', vamCode: '160' },
  { countryCode: 'ES', name: 'Canarias', vamCode: '161' },
  { countryCode: 'ES', name: 'Cantabria', vamCode: '162' },
  { countryCode: 'ES', name: 'Castilla-la Mancha', vamCode: '163' },
  { countryCode: 'ES', name: 'Castilla-Leon', vamCode: '164' },
  { countryCode: 'ES', name: 'Cataluna', vamCode: '165' },
  { countryCode: 'ES', name: 'Ceuta y Melilla', vamCode: '166' },
  { countryCode: 'ES', name: 'Comunidad Valenciana', vamCode: '167' },
  { countryCode: 'ES', name: 'Extremadura', vamCode: '168' },
  { countryCode: 'ES', name: 'Galicia', vamCode: '169' },
  { countryCode: 'ES', name: 'Madrid', vamCode: '170' },
  { countryCode: 'ES', name: 'Murcia', vamCode: '171' },
  { countryCode: 'ES', name: 'Navarra', vamCode: '172' },
  { countryCode: 'ES', name: 'Pais Vasco', vamCode: '173' },
  { countryCode: 'ES', name: 'Rioja', vamCode: '174' },
  { countryCode: 'PT', name: 'Acores', vamCode: '175' },
  { countryCode: 'PT', name: 'Alentejo', vamCode: '176' },
  { countryCode: 'PT', name: 'Algarve', vamCode: '177' },
  { countryCode: 'PT', name: 'Centro', vamCode: '178' },
  { countryCode: 'PT', name: 'Lisboa e vale de Tejo', vamCode: '179' },
  { countryCode: 'PT', name: 'Madeira', vamCode: '180' },
  { countryCode: 'PT', name: 'Norte', vamCode: '181' },
  { countryCode: 'AT', name: 'Burgenland', vamCode: '182' },
  { countryCode: 'AT', name: 'Kärnten', vamCode: '183' },
  { countryCode: 'AT', name: 'Niederösterreich', vamCode: '184' },
  { countryCode: 'AT', name: 'Oberösterreich', vamCode: '185' },
  { countryCode: 'AT', name: 'Salzburg', vamCode: '186' },
  { countryCode: 'AT', name: 'Steiermark', vamCode: '187' },
  { countryCode: 'AT', name: 'Tirol', vamCode: '188' },
  { countryCode: 'AT', name: 'Vorarlberg', vamCode: '189' },
  { countryCode: 'AT', name: 'Wien', vamCode: '190' },
  { countryCode: 'SE', name: 'Mellersta Norrland (Mittleres Nordland)', vamCode: '191' },
  { countryCode: 'SE', name: 'Norra Mellansverige (Nördliches Mittelschweden)', vamCode: '192' },
  { countryCode: 'SE', name: 'Östra Mellansverige (Östliches Mittelschweden)', vamCode: '193' },
  { countryCode: 'SE', name: 'Övre Norrland (Übriges Nordland)', vamCode: '194' },
  { countryCode: 'SE', name: 'Smaland mod öarna (Smaland mit Inseln)', vamCode: '195' },
  { countryCode: 'SE', name: 'Stockholm', vamCode: '196' },
  { countryCode: 'SE', name: 'Sydsverige (Südschweden)', vamCode: '197' },
  { countryCode: 'SE', name: 'Västsverige (Westschweden mit Göteborg)', vamCode: '198' },
  { countryCode: 'FI', name: 'Ahvenanmaa/Äland (Älandinseln)', vamCode: '199' },
  { countryCode: 'FI', name: 'Etelä-Suomi (Südfinnland)', vamCode: '200' },
  { countryCode: 'FI', name: 'Itä-Suomi (Ostfinnland)', vamCode: '201' },
  { countryCode: 'FI', name: 'Pohjois-Suomi (Nordfinnland mit Lappland)', vamCode: '202' },
  { countryCode: 'FI', name: 'Uusimaa (Großstadtregion Helsinki)', vamCode: '203' },
  { countryCode: 'FI', name: 'Väli-Suomi (Westfinnland)', vamCode: '204' },
  { countryCode: 'NO', name: 'Agder/Rogaland (Südnorwegen)', vamCode: '205' },
  { countryCode: 'NO', name: 'Nord-Norge (Nordnorwegen mit Lofoten)', vamCode: '207' },
  { countryCode: 'NO', name: 'Oestlandest (Ostnorwegen mit Oslo)', vamCode: '206' },
  { countryCode: 'NO', name: 'Troendelag (Mittelnorwegen)', vamCode: '208' },
  { countryCode: 'NO', name: 'Westlandet (Westnorwegen)', vamCode: '209' },
  { countryCode: 'CH', name: 'Espace Mittelland (Westschweiz mit Bern)', vamCode: '210' },
  { countryCode: 'CH', name: 'Nordwestschweiz (mit Basel)', vamCode: '211' },
  { countryCode: 'CH', name: 'Ostschweiz (Bodensee bis Graubünden)', vamCode: '212' },
  { countryCode: 'CH', name: 'Région Iémanique (Genfer See bis Wallis)', vamCode: '213' },
  { countryCode: 'CH', name: 'Ticino (Tessin)', vamCode: '214' },
  { countryCode: 'CH', name: 'Zentralschweiz', vamCode: '215' },
  { countryCode: 'CH', name: 'Zürich', vamCode: '216' },
  { countryCode: 'BG', name: 'Severozapaden', vamCode: '218' },
  { countryCode: 'BG', name: 'Severen tsentralen', vamCode: '219' },
  { countryCode: 'BG', name: 'Severoiztochen', vamCode: '220' },
  { countryCode: 'BG', name: 'Yugozapaden', vamCode: '221' },
  { countryCode: 'BG', name: 'Yuzhen tsentralen', vamCode: '222' },
  { countryCode: 'BG', name: 'Yugoiztochen', vamCode: '223' },
  { countryCode: 'CZ', name: 'Praha', vamCode: '224' },
  { countryCode: 'CZ', name: 'Stredni Cechy', vamCode: '225' },
  { countryCode: 'CZ', name: 'Jihozapad', vamCode: '226' },
  { countryCode: 'CZ', name: 'Severozapad', vamCode: '227' },
  { countryCode: 'CZ', name: 'Severovychod', vamCode: '228' },
  { countryCode: 'CZ', name: 'Jihovychod', vamCode: '229' },
  { countryCode: 'CZ', name: 'Stredni Morava', vamCode: '230' },
  { countryCode: 'CZ', name: 'Moravskoslezsko', vamCode: '231' },
  { countryCode: 'ES', name: 'Pohja-Eesti', vamCode: '232' },
  { countryCode: 'ES', name: 'Laane-Eesti', vamCode: '233' },
  { countryCode: 'ES', name: 'Kesk-Eesti', vamCode: '234' },
  { countryCode: 'ES', name: 'Kirde-Eesti', vamCode: '235' },
  { countryCode: 'ES', name: 'Louna-Eesti', vamCode: '236' },
  { countryCode: 'HU', name: 'Kozep-Magyarorszag', vamCode: '237' },
  { countryCode: 'HU', name: 'Kozep-Dunantul', vamCode: '238' },
  { countryCode: 'HU', name: 'Nyugat-Dunantul', vamCode: '239' },
  { countryCode: 'HU', name: 'Del-Dunantul', vamCode: '240' },
  { countryCode: 'HU', name: 'Eszak-Magyarorszag', vamCode: '241' },
  { countryCode: 'HU', name: 'Eszak-Alfold', vamCode: '242' },
  { countryCode: 'HU', name: 'Del-Alfold', vamCode: '243' },
  { countryCode: 'LT', name: 'Alytaus (Apskritis)', vamCode: '244' },
  { countryCode: 'LT', name: 'Kauno (Apskritis)', vamCode: '245' },
  { countryCode: 'LT', name: 'Klaipedos (Apskritis)', vamCode: '246' },
  { countryCode: 'LT', name: 'Marijampoles (Apskritis)', vamCode: '247' },
  { countryCode: 'LT', name: 'Panevezio (Apskritis)', vamCode: '248' },
  { countryCode: 'LT', name: 'Siauliu (Apskritis)', vamCode: '249' },
  { countryCode: 'LT', name: 'Taurages (Apskritis)', vamCode: '250' },
  { countryCode: 'LT', name: 'Telsiu (Apskritis)', vamCode: '251' },
  { countryCode: 'LT', name: 'Utenos (Apskritis)', vamCode: '252' },
  { countryCode: 'LT', name: 'Vilniaus (Apskritis)', vamCode: '253' },
  { countryCode: 'LV', name: 'Riga', vamCode: '254' },
  { countryCode: 'LV', name: 'Vidzeme', vamCode: '255' },
  { countryCode: 'LV', name: 'Kurzeme', vamCode: '256' },
  { countryCode: 'LV', name: 'Zemgale', vamCode: '257' },
  { countryCode: 'LV', name: 'Latgale', vamCode: '258' },
  { countryCode: 'PL', name: 'Dolnoslaskie', vamCode: '259' },
  { countryCode: 'PL', name: 'Kujawsko-Pomorskie', vamCode: '260' },
  { countryCode: 'PL', name: 'Lubelskie', vamCode: '261' },
  { countryCode: 'PL', name: 'Lubuskie', vamCode: '262' },
  { countryCode: 'PL', name: 'Lodzkie', vamCode: '263' },
  { countryCode: 'PL', name: 'Malopolskie', vamCode: '264' },
  { countryCode: 'PL', name: 'Mazowieckie', vamCode: '265' },
  { countryCode: 'PL', name: 'Opolskie', vamCode: '266' },
  { countryCode: 'PL', name: 'Podkarpackie', vamCode: '267' },
  { countryCode: 'PL', name: 'Podlaskie', vamCode: '268' },
  { countryCode: 'PL', name: 'Pomorskie', vamCode: '269' },
  { countryCode: 'PL', name: 'Slaskie', vamCode: '270' },
  { countryCode: 'PL', name: 'Swietokrzyskie', vamCode: '271' },
  { countryCode: 'PL', name: 'Warminsko-Mazurskie', vamCode: '272' },
  { countryCode: 'PL', name: 'Wielkopolskie', vamCode: '273' },
  { countryCode: 'PL', name: 'Zachodniopomorskie', vamCode: '274' },
  { countryCode: 'RO', name: 'Nord-Est', vamCode: '275' },
  { countryCode: 'RO', name: 'Sud-Est', vamCode: '276' },
  { countryCode: 'RO', name: 'Sud', vamCode: '277' },
  { countryCode: 'RO', name: 'Sud-Vest', vamCode: '278' },
  { countryCode: 'RO', name: 'Vest', vamCode: '279' },
  { countryCode: 'RO', name: 'Nord-Vest', vamCode: '280' },
  { countryCode: 'RO', name: 'Centru', vamCode: '281' },
  { countryCode: 'RO', name: 'Bucuresti', vamCode: '282' },
  { countryCode: 'SI', name: 'Pomurska', vamCode: '283' },
  { countryCode: 'SI', name: 'Podravska', vamCode: '284' },
  { countryCode: 'SI', name: 'Koroska', vamCode: '285' },
  // eslint-disable-next-line max-lines
  { countryCode: 'SI', name: 'Savinjska', vamCode: '286' },
  { countryCode: 'SI', name: 'Zasavska', vamCode: '287' },
  { countryCode: 'SI', name: 'Spodnjeposavska', vamCode: '288' },
  { countryCode: 'SI', name: 'Gorenjska', vamCode: '289' },
  { countryCode: 'SI', name: 'Notranjsko-kraska', vamCode: '290' },
  { countryCode: 'SI', name: 'Goriska', vamCode: '291' },
  { countryCode: 'SI', name: 'Obalno-kraska', vamCode: '292' },
  { countryCode: 'SI', name: 'Jugovzhodna Slovenija', vamCode: '293' },
  { countryCode: 'SI', name: 'Osrednjeslovenska', vamCode: '294' },
  { countryCode: 'SI', name: 'Bratislavsky', vamCode: '295' },
  { countryCode: 'SI', name: 'Zapadne Slovensko', vamCode: '296' },
  { countryCode: 'SI', name: 'Stredne Slovensko', vamCode: '297' },
  { countryCode: 'SI', name: 'Vychodne Slovensko', vamCode: '298' },
  { countryCode: 'DK', name: 'Nord-Jütland', vamCode: '299' },
  { countryCode: 'DK', name: 'Mittel-Jütland', vamCode: '300' },
  { countryCode: 'DK', name: 'Süd-Jütland und Fünen', vamCode: '301' },
  { countryCode: 'DK', name: 'Hovedstaden', vamCode: '302' },
  { countryCode: 'DK', name: 'Seeland', vamCode: '303' },
];

export const REGION_NAMES = REGIONS.map(region => region.name);

export const YES_OPTION = '1';
export const NO_OPTION = '0';
export const YES_NO_OPTIONS = [
  { value: YES_OPTION, label: 'ja' },
  { value: NO_OPTION, label: 'nein' },
];

export const OFFER_TYPE_WORKPLACE_ID = '1';
export const OFFER_TYPE_SELF_EMPLOYMENT_ID = '2';
export const OFFER_TYPE_APPRENTICESHIP_ID = '4';
export const OFFER_TYPE_INTERNSHIP_ID = '34';

export const OFFER_TYPE_OPTIONS = [
  { value: OFFER_TYPE_WORKPLACE_ID, label: 'Arbeitsplatz' },
  { value: OFFER_TYPE_SELF_EMPLOYMENT_ID, label: 'Selbständigkeit' },
  { value: OFFER_TYPE_APPRENTICESHIP_ID, label: 'Ausbildung/Duales Studium' },
  { value: OFFER_TYPE_INTERNSHIP_ID, label: 'Praktikum/Traineestelle' },
];

export const EMPLOYMENT_TYPE_TO_OFFER_TYPE_MAP: {
  [employmentType: string]: (typeof OFFER_TYPE_OPTIONS)[0];
} = {
  contract: OFFER_TYPE_OPTIONS[1],
  internship: OFFER_TYPE_OPTIONS[3],
};

export const JOB_OFFER_TYPES = [
  OFFER_TYPE_WORKPLACE_ID,
  OFFER_TYPE_SELF_EMPLOYMENT_ID,
  OFFER_TYPE_INTERNSHIP_ID,
];

export const EDUCATION_OFFER_TYPES = [OFFER_TYPE_APPRENTICESHIP_ID];

export const WORKING_PLAN_OPTIONS = [
  { value: '1', label: 'Vollzeit', types: [WorkingPlanType.REGULAR, WorkingPlanType.EDUCATION] },
  { value: '2', label: 'Schicht / Nacht / Wochenende', types: [WorkingPlanType.REGULAR] },
  {
    value: '7',
    label: 'Teilzeit - Vormittag',
    types: [WorkingPlanType.REGULAR, WorkingPlanType.EDUCATION],
  },
  {
    value: '8',
    label: 'Teilzeit - Nachmittag',
    types: [WorkingPlanType.REGULAR, WorkingPlanType.EDUCATION],
  },
  { value: '9', label: 'Teilzeit - Abend', types: [WorkingPlanType.REGULAR] },
  { value: '10', label: 'Teilzeit - flexibel', types: [WorkingPlanType.EDUCATION] },
  { value: '11', label: 'Heimarbeit / Telearbeit', types: [WorkingPlanType.REGULAR] },
];

export const WORKING_PLAN_REGULAR_OPTIONS = WORKING_PLAN_OPTIONS.filter(option =>
  option.types.includes(WorkingPlanType.REGULAR),
);
export const WORKING_PLAN_EDUCATION_OPTIONS = WORKING_PLAN_OPTIONS.filter(option =>
  option.types.includes(WorkingPlanType.EDUCATION),
);

export const EMPLOYMENT_TYPE_TO_WORKING_PLAN_MAP: {
  [employmentType: string]: (typeof WORKING_PLAN_OPTIONS)[0];
} = {
  fulltime: WORKING_PLAN_OPTIONS[0],
  parttime: WORKING_PLAN_OPTIONS[1],
};

export const EDUCATION_TYPE_TRAINING_ID = '0';
export const EDUCATION_TYPE_DUAL_STUDY_ID = '1';
export const EDUCATION_TYPE_OPTIONS = [
  { value: EDUCATION_TYPE_TRAINING_ID, label: 'Ausbildung' },
  { value: EDUCATION_TYPE_DUAL_STUDY_ID, label: 'Duales Studium' },
];

export const DEGREE_TYPE_PRACTICE_ID = '1';
export const DEGREE_TYPE_TRAINING_ID = '2';
export const DEGREE_TYPE_OPTIONS = [
  { value: DEGREE_TYPE_PRACTICE_ID, label: 'praxisintegrierend' },
  { value: DEGREE_TYPE_TRAINING_ID, label: 'ausbildungsintegrierend' },
];

// Example valid partner number: 15123
export const PARTNER_NUMBER_PATTERN = /^ *\d+ *$/;
// Example valid customer number: A123A98765
export const CUSTOMER_NUMBER_PATTERN =
  /^ *[ABCEFGHJKLMNPQRSTUVWXYZ]{1}[0-9]{3}[ABCDEFGHJKLMNPQRSTUVWXY]{1}[0-9]{5} *$/;
// Example valid supplier id: V000123456
export const SUPPLIER_ID_PATTERN = /^ *[PVK]{1}[0-9]{9} *$/;
